export default "__VITE_ASSET__CMuDNih4__"